import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function fetch$ref() {
  return constructCallableReference((p0, p1) => fetch(p0, p1), 2, 0, 226, 'fetch');
}
//region block: exports
export {
  fetch$ref as fetch$ref1cv1mtoh9qodz,
};
//endregion

//# sourceMappingURL=LibDom.mjs.map
